module.exports = __webpack_public_path__ + "img/world.f6fc3281.svg";